import ExpiredLink from './ExpiredLink';

export default ExpiredLink;
